// extracted by mini-css-extract-plugin
export var courseStructure = "courseStructure-module--course-structure--09106";
export var courseStructure__col = "courseStructure-module--course-structure__col--a87bb";
export var courseStructure__description = "courseStructure-module--course-structure__description--437ba";
export var courseStructure__subtitle = "courseStructure-module--course-structure__subtitle--e4d20";
export var courseStructure__text = "courseStructure-module--course-structure__text--c170d";
export var courseStructure__wrapper = "courseStructure-module--course-structure__wrapper--1015b";